import { render, staticRenderFns } from "./videoThumbnail.vue?vue&type=template&id=2d168b0c&scoped=true"
import script from "./videoThumbnail.vue?vue&type=script&lang=js"
export * from "./videoThumbnail.vue?vue&type=script&lang=js"
import style0 from "./videoThumbnail.vue?vue&type=style&index=0&id=2d168b0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d168b0c",
  null
  
)

export default component.exports